<div class="modal-backdrop fade show" *ngIf="visible" @backdropFade [@.disabled]="animationsDisabled" (click)="hide()"></div>
<!--todo: animate modal on leave (currently host opacity is animated)-->
<div class="modal show" *ngIf="visible" @enterLeave [@.disabled]="animationsDisabled" [ngClass]="{'centerVertical': centerVertical}">
  <div class="modal-dialog modal-{{size}} modal-dialog-scrollable" [ngClass]="classes">
    <router-outlet></router-outlet>
  </div>
</div>
